export const iosLink = "https://apps.apple.com/us/app/wishbox-finance/id1517031842";
export const androidLink = "";
export const webLink = "https://wishboxapp.com/";
export const contactEmail = "wishboxappinfo@gmail.com";
export const contactMailto =
	"mailto:wishboxappinfo@gmail.com?subject=Web Support&body=If you are experiencing troubles with subscription, please click the reach out button through the wishbox app, in order to auto-fill your id, to help us identify the subscription. :)";
export const facebookLink = "https://www.facebook.com/wishboxapp/";

export const defaultTitle = "Wishbox 2.0 — Label your savings for wishes and future expenses";
export const defaultDescription =
	"Wishbox 2.0 is out now on iPhone, iPad, Mac, and Apple Watch. Label savings for wishes and future expenses, track spending with AI, and collaborate on shared items. Android and Wear OS are coming soon with the same app. Local-first with optional iCloud or Google Drive.";
